<p>comparison-dates-holder works!</p>

<mat-slide-toggle (change)="onToggle($event)">Comparison Dates</mat-slide-toggle>

<div class="comparison-dates-container" *ngIf="showCDs">
  <siq-js-comparison-dates></siq-js-comparison-dates>
</div>